import $ from 'jquery';

(($) => {
  $.fn.microcarousel = function (options) {
    const settings = $.extend({
      timer_latency: 200
    }, options);

    return this.each(function() {
      let timer, $wrapper = $(this);

      $wrapper.children().addClass('slide');

      timer = setTimeout(switch_slide, $wrapper.find('.slide:eq(0)').text().length * settings.timer_latency);

      function switch_slide() {
        $wrapper.find('.slide:eq(0)').animate({'margin-top': -$wrapper.height()}, function() {
          $(this).css({'margin-top': 0}).appendTo($wrapper);
          clearTimeout(timer);
          timer = setTimeout(switch_slide, $(this).text().length * settings.timer_latency);
        });
      }
    });
  };

  const selector = '.js--bj--hero-title';
  const types = window.ntHeroTypes || ['Road trip'];
  const $span = $(selector);

  const $wrap = $('<ul />');

  types.forEach(type => {
    $wrap.append('<li>' + type + '</li>');
  });

  $span.html($wrap);

  $wrap.microcarousel();
})($);
